import { Component } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { HeaderTextIconComponent } from '../header-text-icon/header-text-icon.component';

@Component({
  selector: 'app-header-tablet-and-mobile',
  standalone: true,
  imports: [ToolbarModule, HeaderTextIconComponent],
  templateUrl: './header-tablet-and-mobile.component.html',
  styleUrls: ['./header-tablet-and-mobile.component.scss'],
})
export class HeaderTabletAndMobileComponent {}
